import SelectRoom from '@/views/SelectRoom/index.vue'

const SelectRoomRouter = {
  path: '/select-room',
  name: 'SelectRoom',
  component: SelectRoom,
  props: (route) => ({
    secret: route.query.secret,
    pax_voucher_id: route.query.pax_voucher_id
  })
}

export default SelectRoomRouter
